"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldUpdateRecoveryInfo = exports.hasPastDueSubscription = exports.hasNoSubscription = exports.hasIncompleteSubscription = exports.hasActiveSubscription = exports.getUnpaidInvoiceUrl = exports.getPhoneNumber = exports.getIsHostedOutsideMailcore = exports.getIsChargeable = exports.getExpiresAt = void 0;
var _objects = require("../../utils/objects");
const getExpiresAt = account => (0, _objects.getObjectProperty)(account, 'expires_at');
exports.getExpiresAt = getExpiresAt;
const getIsChargeable = account => (0, _objects.getObjectProperty)(account, 'is_chargeable');
exports.getIsChargeable = getIsChargeable;
const getIsHostedOutsideMailcore = account => (0, _objects.getObjectProperty)(account, 'is_hosted_outside_mailcore');
exports.getIsHostedOutsideMailcore = getIsHostedOutsideMailcore;
const getUnpaidInvoiceUrl = account => (0, _objects.getObjectProperty)(account, 'unpaid_invoice_url');
exports.getUnpaidInvoiceUrl = getUnpaidInvoiceUrl;
const getPhoneNumber = account => (0, _objects.getObjectProperty)(account, 'current_phone_number');
exports.getPhoneNumber = getPhoneNumber;
const hasNoSubscription = (account, customer) => {
  const isLegacyPayments = String((0, _objects.getObjectProperty)(account, 'legacy_payments')) === '1';
  if (!isLegacyPayments) {
    return (0, _objects.getObjectProperty)(account, 'subscription_status') === null;
  }
  const legacySubscriptions = customer?.subscriptions.data;
  const activeLegacySubscription = legacySubscriptions?.find(subscription => subscription && subscription.status === 'active');
  return !activeLegacySubscription;
};
exports.hasNoSubscription = hasNoSubscription;
const shouldUpdateRecoveryInfo = account => (0, _objects.getObjectProperty)(account, 'should_update_recovery_info');
exports.shouldUpdateRecoveryInfo = shouldUpdateRecoveryInfo;
const hasActiveSubscription = account => String((0, _objects.getObjectProperty)(account, 'subscription_status')) === 'active';
exports.hasActiveSubscription = hasActiveSubscription;
const hasPastDueSubscription = account => String((0, _objects.getObjectProperty)(account, 'subscription_status')) === 'past_due';
exports.hasPastDueSubscription = hasPastDueSubscription;
const hasIncompleteSubscription = account => String((0, _objects.getObjectProperty)(account, 'subscription_status')) === 'incomplete';
exports.hasIncompleteSubscription = hasIncompleteSubscription;